export { default } from './TAGSvgIcon';
export * from './TAGSvgIcon';
